var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SignLoading',{on:{"cancel":_vm.onLoadingCancel}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.debug),expression:"debug"}]},[_vm._v(_vm._s(_vm.checked)+_vm._s(_vm.pos))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }